// extracted by mini-css-extract-plugin
export var carrierNotice = "_m2-5";
export var carrierNoticePlaceholder = "_m2-6";
export var deliveryRow = "_m2-c";
export var fixedHeight = "_m2-4";
export var freightLogo = "_m2-b";
export var fullWidth = "_m2-3";
export var priceColumn = "_m2-7";
export var radioSelected = "_m2-9";
export var radioUnselected = "_m2-8";
export var selectedOption = "_m2-2";
export var selectedOptionContainer = "_m2-1";
export var selection = "_m2-0";
export var tallSkeletonText = "_m2-a";